const dateList = {
  ALL: false,
  lastDay: false,
  lastWeek: false,
  lastMonth: false,
  lastYear: false,
};

export default dateList;
